//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import DJAreaSideMenu from './sidemenu';
import CopyBox from '../components/bbcode/copy-box';
import Image from '../components/image/image';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './css/adminlte.css';
import './css/djarea.css';

export default class DJAreaTemplates extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			obs_id: '',

		};
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		let params = new URLSearchParams();
		const x = await postApi('/api/v2/djarea/templates', params);
		if( x.status === 200 ) this.setState({status: true, obs_id: x.data.obs_id});
	}

	componentWillUnmount() {
	}

	render() {
		return (
			<Row className="dj-area pt-4 pb-5 px-4">
				<Col xs={12} md={2} className="djarea-sidemenu">
					<DJAreaSideMenu />
				</Col>
				{this.state.status &&
					<Col>
					
						<Row>
							<Col xs={12}>
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">Mix365 OBS Templates</h3>
									</div>
									<div className="card-body">
										We have a range of OBS templates to use in your OBS to give more interaction with the listeners from both Mix365 and Twitch.<br />
										There are no downloads required for this and can simply be installed via OBS through the Browser Plugin.<br />
										Some of the templates are channel dependant Emotes/Emojis, Giphy/Tenor and Messaging and you will not recieve data until 1 hour before your scheduled set time.<br /><br />
										Mix365 Clubbers Requirement:<br /><br />
										<Row>
											<Col md={3} className="text-center">
												<a href="#overlay">
													Mix365 Overlay
													<img src="/images/docs/overlay-1.png" width="100%" alt="Overlay" />
												</a>
											</Col>
										</Row>
										<br /><br />
										The follow templates are optional:<br /><br />
										<Row>
											<Col md={3} className="text-center">
												<a href="#emotesemojis">
													Emotes/Emojis
													<img src="/images/docs/emotes-1.png" width="100%" alt="Emotes/Emojis" />
												</a>
											</Col>
											<Col md={3} className="text-center">
												<a href="#giphytenor">
													Giphy/Tenor
													<img src="/images/docs/giphy-1.png" width="100%" alt="Giphy/Tenor" />
												</a>
											</Col>
											<Col md={3} className="text-center">
												<a href="#messaging">
													Messaging
													<img src="/images/docs/messaging-1.png" width="100%" alt="Messaging" />
												</a>
											</Col>
											<Col md={3} className="text-center">
												<a href="#webchats">
													Web Chats
													<img src="/images/docs/chatbox-1.png" width="100%" alt="WebChats" />
												</a>
											</Col>
											<Col md={3} className="text-center">
												<a href="#systemclock">
													System Clock
													<img src="/images/docs/clock-1.png" width="100%" alt="SystemClock" />
												</a>
											</Col>
											{/*
											<Col md={3} className="text-center">
												<a href="#globe">
													Listener Globe
													<img src="/images/docs/globe-1.png" width="100%" alt="Messaging" />
												</a>
											</Col>
											*/}
										</Row>

									</div>
								</div>
							</Col>

							<Col xs={12} id="overlay">
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">Mix365 Overlay Template</h3>
									</div>
									<div className="card-body">
										<Row className="gx-0">
											<Col md={6} className="text-vcenter pb-3">
												<Image src="/images/docs/overlay-1.png" alt="Overlay" width="75%" />
											</Col>
											<Col xs={12} className="pb-3">
												Notes:<br />
												Can be used on either channel and is required for the clubbers channel,<br />
												The initial screen that is displayed is only for your own reference indicating which templates you currently have active in your session,<br />
												<br />
												Not implemented as of yet and will be used for several things:<br />
												Advertise next DJ coming on,<br />
												advertise events, news and any other important infomration
											</Col>
											<Col xs={12}>
												<h3>Installation</h3>
											</Col>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												Click + In the Sources dialogue<br />
												Followed by select Browser<br /><br />
												<img src="/images/docs/overlay-2.png" alt="Overlay" width="50%" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												Enter a Name e.g.<br />
												Mix365 Overlay<br /><br />
												<img src="/images/docs/overlay-3.png" alt="Overlay" width="50%" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												Ensure this Scene's<br />
												positioning is at the top<br /><br />
												<img src="/images/docs/overlay-4.png" alt="Overlay" width="50%" />
											</div>
											
											<Col xs={12} className="pb-3">
												New popup dialogue box will appear and change the settings to show the same as this:
											</Col>

											<div className="col-lg-7 pb-3 text-vertical">
												<Image src="/images/docs/overlay-5.png" alt="Overlay" width="75%" />
											</div>

											<Col xs={12}></Col>

											<Col md={6} className="pb-3">
												URL:<br />
												<CopyBox content={this.state.obs_id?`https://mix365.co.uk/templates/overlay/${this.state.obs_id}`:``} />

												Width:<br />
												<CopyBox content="1280" />

												Height:<br />
												<CopyBox content="720" />

												Refresh browser when source become active<br />
												Page Permissions: Read access to OBS status information<br />
												
												
											</Col>
										</Row>

									</div>
									<div className="card-header">
										<h3 className="card-title">Now Playing 2</h3>
									</div>
									<div className="card-body">
											<Row>
												<Col md={12}>
												<a href="https://www.nowplaying2.com/" target="_blank" rel="noreferrer"><img src="/images/docs/np2.png" alt="Now Playing 2" width="200" /></a><br /><br />
													The Easiest Track ID App For Live Streaming DJs, download here<br />
													<a href="https://www.nowplaying2.com/" target="_blank" rel="noreferrer">https://www.nowplaying2.com/</a>
													<br /><br />
													Notes:<br />
													The overlay template connects to your now playing 2 automatically to pick up your TrackID's and will display them directly on the website<br /><br />
													Required:<br />
													Please keep the initial default port that is supplied with Now Playing 2 and the port is 9000<br />
													Your Now Playing 2 and your OBS must be running on the same computer/laptop for it to connect and pick up the track ID's<br /><br />
													
													Optional:<br />
													After Installation of Now Playing 2, you do not need to follow the steps to include the overlay into your OBS<br /><br />
													Album Art:<br />
													At the moment we currently don't have any way to obtain the album art directly from your Now Playing 2 and therefore cannot be shown.
												</Col>
											</Row>
									</div>
								</div>
							</Col>

							<Col xs={12} id="emotesemojis">
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">OBS Template - Emotes/Emojis</h3>
									</div>
									<div className="card-body">
										<Row className="gx-0">
											<div className="col-lg-6 p-3" style={{display: 'flex', justifyContent:'center', alignItems: 'center', fontSize: 18}}>
												<u>Install - Mix365 Emotes/Emojis</u>
											</div>
											<div className="col-lg-6 p-3">
												<img src="/images/docs/emotes-1.png" width="75%" alt="Emotes/Emojis" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												Click + In the Sources dialogue<br />
												Followed by select Browser<br /><br />
												<img src="/images/docs/overlay-2.png" alt="Emotes/Emojis" width="50%" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												Enter a Name e.g.<br />
												Mix365 Emotes-Emojis<br /><br />
												<img src="/images/docs/emotes-3.png" alt="Emotes/Emojis" width="50%" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												<br />Position to your own choosing<br /><br />
												<img src="/images/docs/emotes-4.png" alt="Emotes/Emojis" width="50%" />
											</div>
											
											<div className="col-lg-5" style={{fontSize: 14}}>
												<br />Browser Settings:<br /><br />
												URL:<br />
												<CopyBox content={this.state.obs_id?`https://mix365.co.uk/templates/emotes/${this.state.obs_id}`:``} />

												Width:<br />
												<CopyBox content="1280" />

												Height:<br />
												<CopyBox content="720" />

												Page Permissions: Read access to OBS status information<br /><br />
												* Important Notes:<br />
												Different resolution: Use the width and height mentioned above and adjust the box to fit your screen
											</div>
											<div className="col-lg-7 pb-3 text-center">
												<img src="/images/docs/emotes-5.png" alt="Emotes/Emojis" width="75%" />
											</div>
										</Row>

									</div>
								</div>
							</Col>

							<Col xs={12} id="giphytenor">
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">OBS Template - Giphy/Tenor</h3>
									</div>
									<div className="card-body">
										<Row className="gx-0">
											<div className="col-lg-6 p-3" style={{display: 'flex', justifyContent:'center', alignItems: 'center', fontSize: 18}}>
												<u>Install - Mix365 Giphy/Tenor</u>
											</div>
											<div className="col-lg-6 p-3">
												<img src="/images/docs/giphy-1.png" width="75%" alt="Giphy/Tenor" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												Click + In the Sources dialogue<br />
												Followed by select Browser<br /><br />
												<img src="/images/docs/overlay-2.png" alt="Giphy/Tenor" width="50%" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												Enter a Name e.g.<br />
												Mix365 Giphy-Tenor<br /><br />
												<img src="/images/docs/giphy-3.png" alt="Giphy/Tenor" width="50%" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												<br />Position to your own choosing<br /><br />
												<img src="/images/docs/giphy-4.png" alt="Giphy/Tenor" width="50%" />
											</div>

											<div className="col-lg-5" style={{fontSize: 14}}>
												<br />Browser Settings:<br /><br />
												URL:<br />
												<CopyBox content={this.state.obs_id?`https://mix365.co.uk/templates/giphytenor/${this.state.obs_id}`:``} />

												Width:<br />
												<CopyBox content="500" />

												Height:<br />
												<CopyBox content="300" />

												Page Permissions: Read access to OBS status information
											</div>
											<div className="col-lg-7 pb-3 text-center">
												<img src="/images/docs/giphy-5.png" alt="Giphy/Tenor" width="50%" />
											</div>

											<div className="col-lg-5" style={{display: 'flex', justifyContent:'left', alignItems: 'center', fontSize: 14}}>
												Position in OBS to your own choosing
											</div>
											<div className="col-lg-7 pb-3 text-center">
												<img src="/images/docs/giphy-6.png" alt="Giphy/Tenor" width="50%" />
											</div>
										</Row>

									</div>
								</div>
							</Col>

							<Col xs={12} id="messaging">
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">OBS Template - Messaging</h3>
									</div>
									<div className="card-body">
										<Row className="gx-0">
											<div className="col-lg-6 p-3" style={{display: 'flex', justifyContent:'center', alignItems: 'center', fontSize: 18}}>
												<u>Install - Mix365 Messaging</u>
											</div>
											<div className="col-lg-6 p-3">
												<img src="/images/docs/messaging-1.png" width="75%" alt="Messaging" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												Click + In the Sources dialogue<br />
												Followed by select Browser<br /><br />
												<img src="/images/docs/overlay-2.png" alt="Messaging" width="50%" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												Enter a Name e.g.<br />
												Mix365 Messaging<br /><br />
												<img src="/images/docs/messaging-3.png" alt="Messaging" width="50%" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												<br />Position to your own choosing<br /><br />
												<img src="/images/docs/messaging-4.png" alt="Messaging" width="50%" />
											</div>
											
											<div className="col-lg-5" style={{fontSize: 14}}>
												<br />Browser Settings:<br /><br />
												URL:<br />
												<CopyBox content={this.state.obs_id?`https://mix365.co.uk/templates/messaging/${this.state.obs_id}`:``} />

												Width:<br />
												<CopyBox content="1280" />

												Height:<br />
												<CopyBox content="720" />

												Page Permissions: Read access to OBS status information<br /><br />
												* Important Notes:<br />
												Different resolution: Use the width and height mentioned above and adjust the box to fit your screen
											</div>
											<div className="col-lg-7 pb-3 text-center">
												<img src="/images/docs/messaging-5.png" alt="Messaging" width="75%" />
											</div>
										</Row>

									</div>
								</div>
							</Col>

							<Col xs={12} id="webchats">
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">OBS Template - Web Chats</h3>
									</div>
									<div className="card-body">
										<Row className="gx-0">
											<div className="col-lg-6 p-3" style={{display: 'flex', justifyContent:'center', alignItems: 'center', fontSize: 18}}>
												<u>Install - Mix365 Chatbox</u>
											</div>
											<div className="col-lg-6 p-3">
												<img src="/images/docs/chatbox-1.png" width="75%" alt="Chatbox" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												Click + In the Sources dialogue<br />
												Followed by select Browser<br /><br />
												<img src="/images/docs/overlay-2.png" alt="Chatbox" width="50%" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												Enter a Name e.g.<br />
												Mix365 Chatbox<br /><br />
												<img src="/images/docs/chatbox-3.png" alt="Chatbox" width="50%" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												<br />Position to your own choosing<br /><br />
												<img src="/images/docs/chatbox-4.png" alt="Chatbox" width="50%" />
											</div>
											
											<div className="col-lg-5" style={{fontSize: 14}}>
												<br />Browser Settings:<br /><br />
												Clubbers URL:<br />
												<CopyBox content={this.state.obs_id?`https://mix365.co.uk/templates/chatbox/${this.state.obs_id}/clubbers`:``} />
												
												Radio URL:<br />
												<CopyBox content={this.state.obs_id?`https://mix365.co.uk/templates/chatbox/${this.state.obs_id}/radio`:``} />

												Width:<br />
												<CopyBox content="400" />

												Height:<br />
												<CopyBox content="600" />

												Page Permissions: Read access to OBS status information<br /><br />
												Important Notes:<br />
												Please adjust width and height to your own resolution to what best suits your layout
											</div>
											<div className="col-lg-7 pb-3 text-center">
												<img src="/images/docs/chatbox-5.png" alt="Chatbox" width="75%" />
											</div>
										</Row>

									</div>
								</div>
							</Col>

							<Col xs={12} id="systemclock">
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">OBS Template - Clock</h3>
									</div>
									<div className="card-body">
										<Row className="gx-0">
											<div className="col-lg-6 p-3" style={{display: 'flex', justifyContent:'center', alignItems: 'center', fontSize: 18}}>
												<u>Install - Mix365 Clock</u>
											</div>
											<div className="col-lg-6 p-3">
												<img src="/images/docs/clock-1.png" width="75%" alt="Clock" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												Click + In the Sources dialogue<br />
												Followed by select Browser<br /><br />
												<img src="/images/docs/overlay-2.png" alt="Clock" width="50%" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												Enter a Name e.g.<br />
												Mix365 Clock<br /><br />
												<img src="/images/docs/clock-3.png" alt="Clock" width="50%" />
											</div>
											
											<div className="col-lg-4 pb-3 text-center" style={{fontSize: 14}}>
												<br />Position to your own choosing<br /><br />
												<img src="/images/docs/clock-4.png" alt="Clock" width="50%" />
											</div>
											
											<div className="col-lg-5" style={{fontSize: 14}}>
												<br />Browser Settings:<br /><br />
												URL:<br />
												<CopyBox content={this.state.obs_id?`https://mix365.co.uk/templates/clock`:``} />

												Width:<br />
												<CopyBox content="900" />

												Height:<br />
												<CopyBox content="50" />

												
											</div>
											<div className="col-lg-7 pb-3 text-center">
												<img src="/images/docs/clock-5.png" alt="Clock" width="75%" />
											</div>
										</Row>

									</div>
								</div>
							</Col>

						</Row>
					</Col>
				}
			</Row>
		);
	}
}
